import { render } from "./AnalisiDelTalento.vue?vue&type=template&id=0d89a3e8&scoped=true"
import script from "./AnalisiDelTalento.vue?vue&type=script&lang=js"
export * from "./AnalisiDelTalento.vue?vue&type=script&lang=js"

import "./AnalisiDelTalento.vue?vue&type=style&index=0&id=0d89a3e8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d89a3e8"]])

export default __exports__